<script>
const name = 'templateCausaRisco'

export default {
  name,

  components: { },

  props: {
    dataCausa: {
      type: Object,
      default: () => {}
    }
  },

  mounted () { },

  updated () { },

  data () {
    return { }
  },

  methods: { },

  computed: { }

}

</script>

<template>
    <li>
        {{dataCausa}}
    </li>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/private/apr/templateApr/components/detalhesTemplate/components/templateCausaRisco.vue